<template>
  <vue-good-table
      :columns="columns"
      :rows="datas"
      :select-options="selectOptions"
      :mode="tableMode"
      :pagination-options="paginationTranslated"
      :groupOptions="groupOptions"
      @on-selected-rows-change="updateIdsSelecteds"
      @on-page-change="onPageChange"
      @on-sort-change="onSortChange"
      @on-column-filter="onColumnFilter"
      @on-per-page-change="onPerPageChange"
      :totalRows="totalRecords"
      :styleClass="styleClass"
  >
    <template slot="table-row" slot-scope="props">
      <span v-if="props.column.td_bool">
        <span class="badge bg-green" v-if="props.formattedRow[props.column.field]">
          <i class="fa fa-check-circle"></i>
        </span>
        <span class="badge bg-gray" v-if="!props.formattedRow[props.column.field]">
          <i class="fa fa-ban"></i>
        </span>
      </span>

      <span v-else-if="props.column.customType">
        <a
            v-if="props.column.customType"
            href="javascript:void(0)"
            :class="props.column.class"
            v-on:click="props.column.callback(props.row)"
        >
          <i :class="props.column.icon"></i>
          {{ props.column.tdLabel || props.formattedRow[props.column.field] }}
        </a>
      </span>

      <span
          v-else-if="props.column.customTypeExam && props.column.class && props.row[props.column.field] != null && props.row.status == 'Blocked'">
        <a
            href="javascript:void(0)"
            :class="props.column.class"
            v-on:click="props.column.callback(props.row)"
        >
          {{ props.row[props.column.field] }}
        </a>
         <i :class="props.column.icon"></i>

      </span>

      <span v-else-if="props.column.customTypeStatus && props.row[props.column.field] == 'Blocked'">
        <a
            href="javascript:void(0)"
            :class="props.column.class"
            v-on:click="props.column.callback(props.row)"
        >
          {{ props.column.dangerLabel }}
        </a>
         <i :class="props.column.icon"></i>

      </span>

      <span v-else-if="props.column.customTypeStatus && props.row[props.column.field] == null">
        <a
            href="javascript:void(0)"
            :class="props.column.classSucess"
            v-on:click="props.column.callback(props.row)"
        >
          {{ props.column.sucessLabel }}
        </a>
         <i :class="props.column.icon"></i>

      </span>

      <span v-else-if="props.column.customTypeStatus && props.row[props.column.field] == 'Alert'">
        <a
            href="javascript:void(0)"
            :class="props.column.classWarning"
            v-on:click="props.column.callback(props.row)"
        >
          {{ props.column.warningLabel }}
        </a>
         <i :class="props.column.icon"></i>

      </span>

      <span v-else>{{ props.formattedRow[props.column.field] }}</span>
    </template>
    <div slot="table-actions">
      <div class="button-group">
        <button
            type="button"
            class="btn btn-default btn-sm"
            v-if="ids.length > 1 && bulk"
            v-on:click="openBulkPage"
        >
          <i class="fa fa-edit" aria-hidden="true"></i>
          {{ lang_editar }}
        </button>

        <button type="button" class="btn btn-default btn-sm dropdown-toggle" data-toggle="dropdown">
          <i class="fa fa-cog" aria-hidden="true"></i>
          <span class="caret"></span>
        </button>
        <ul class="dropdown-menu" style="top: auto; left: auto;">
          <li v-for="(column, index) in columns" :key="index">
            <a href="#" class="small" tabindex="-1" v-on:click="toggleColumn( index, $event )">
              <input :checked="!column.hidden" type="checkbox"/>
              &nbsp;{{ column.label }}
            </a>
          </li>
          <li>
            <a href="#" class="small" tabindex="-1" v-on:click="toggleAll(columns)">
              <input type="checkbox" :checked="all"/>
              &nbsp;{{ $t('components.data_table.todos') }}
            </a>
          </li>
        </ul>

        <button type="button" class="btn btn-default btn-sm" v-on:click="activeFilter(columns)">
          <i class="fa fa-search" aria-hidden="true"></i>
        </button>
      </div>
    </div>
    <div slot="emptystate">{{ $t('components.data_table.nenhum_resultado_encontrado') }}</div>
  </vue-good-table>
</template>

<script>
import 'vue-good-table/dist/vue-good-table.css'
import $axios from '@/providers/AxiosServiceProvider'
import {VueGoodTable} from 'vue-good-table'
import HttpStatus from 'http-status-codes'

export default {
  name: 'data-table',
  components: {
    VueGoodTable
  },
  props: {
    columns: {
      type: [Array, Object],
      required: true
    },
    datas: {
      type: [Array],
      required: false
    },
    pagination: {
      type: Object,
      required: false,
      default: () => ({
        enabled: true,
        perPage: 15,
        position: 'bottom',
        rowsPerPageLabel: 'Linhas por página',
        nextLabel: 'Próximo',
        prevLabel: 'Anterior',
        mode: 'pages',
        dropdownAllowAll: false,
        isDefault: true
      })
    },
    search: {
      type: Object,
      required: false
    },
    service: {
      type: String,
      required: false
    },
    styleClass: {
      type: String,
      default: 'table table-striped table-hover dataTable',
      required: false
    },
    selectOptions: {
      type: Object,
      required: false,
      default: () => ({
        enabled: true
      })
    },
    headerButtons: {
      type: Array,
      required: false
    },
    bottomButtons: {
      type: Array,
      required: false
    },
    eventsHandler: {
      type: Object,
      required: false
    },
    tableMode: {
      type: String,
      required: false,
      default: 'pages'
    },
    bulk: {
      type: Boolean,
      required: false,
      default: true
    },
    lang_proximo: {
      type: String
    },
    lang_anterior: {
      type: String
    },
    lang_linhas: {
      type: String
    },
    lang_acoes: {
      type: String
    },
    lang_alterar: {
      type: String
    },
    lang_excluir: {
      type: String
    },
    lang_adicionar: {
      type: String
    },
    lang_tabela_vazia: {
      type: String
    },
    lang_editar: {
      type: String
    },
    totalRecords: {
      type: Number,
      required: false,
      default: 15
    },
    groupOptions: {
      type: Object,
      required: false,
      default: () => ({
        enabled: false
      })
    }
  },
  data() {
    return {
      ids: [],
      all: false,
      columnsTypes: [],
      serverParams: {
        filters: [],
        orderBy: [],
        page: 1,
        per_page: this.pagination.perPage
      },
      totalRows: this.totalRecords,
      rows: []
    }
  },
  computed: {
    paginationTranslated() {
      if (this.$props.pagination.isDefault === true) {
        this.$props.pagination.rowsPerPageLabel = this.$t('components.data_table.linhas_por_pagina')
        this.$props.pagination.nextLabel =  this.$t('components.data_table.proximo')
        this.$props.pagination.prevLabel = this.$t('components.data_table.anterior')        
      }

      return this.$props.pagination
    }
  },
  methods: {
    openEditPage(id) {
      this.$emit('openEditPage', id)
    },

    updateIdsSelecteds(params) {
      if (this.eventsHandler && this.eventsHandler.onSelectRow) {
        this.eventsHandler.onSelectRow(params)
      } else {
        let ids = []
        params.selectedRows.forEach(param => {
          ids.push(param.id)
        })
        this.ids = ids
      }
    },

    openBulkPage() {
      this.$emit('openBulkPage', this.ids)
    },

    addItem(item) {
      this.$emit('addItem', item)
    },

    deleteItem(id) {
      this.$emit('deleteItem', id)
    },

    toggleColumn(index, event) {
      this.$set(this.columns[index], 'hidden', !this.columns[index].hidden)
    },

    activeFilter(columns) {
      columns.forEach(column => {
        if (column.filterOptions) {
          if (!column.td_bool) {
            column.filterOptions.filterFn = this.collumnFilterFn
          }

          if (column.filterOptions.enabled) {
            column.filterOptions.enabled = false
          } else {
            column.filterOptions.enabled = true
          }
        }
      })
    },

    toggleAll(columns) {
      let x = 0
      if (!this.all) {
        this.all = true
        columns.forEach(column => {
          this.toggleColumn(x, null)
          column.hidden = false
          x++
        })
      } else {
        this.all = false
        columns.forEach(column => {
          this.toggleColumn(x, null)
          column.hidden = true
          x++
        })
      }

      return false
    },

    collumnFilterFn(data, filterString) {
      let field = data
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toLowerCase()
      let filter = filterString
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toLowerCase()

      return field.indexOf(filter) >= 0
    },

    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps)
    },

    onPageChange(params) {
      this.updateParams({page: params.currentPage})
      this.loadItems(true)
    },

    onPerPageChange(params) {
      this.updateParams({per_page: params.currentPerPage})
      this.loadItems(true)
    },

    onSortChange(params) {
      let order = {orderBy: []}
      for (
          let index = 0, lastElement = params.length;
          index < lastElement;
          index++
      ) {
        let orderRow = []
        orderRow.push(params[index].field)
        orderRow.push(params[index].type)
        order.orderBy.push(orderRow)
      }

      this.updateParams(order)
      this.loadItems()
    },

    onColumnFilter(params) {
      let filter = []
      const minimalLength = 3
      let canSearch = true
      const operator = 'LIKE'
      const percent = '%'

      for (let field in params.columnFilters) {
        let aux = []
        if (params.columnFilters[field].length < minimalLength) {
          continue
        }

        aux.push(field)
        aux.push(operator)
        aux.push(percent + params.columnFilters[field] + percent)
        filter.push(aux)
      }
      if (canSearch) {
        delete params.columnFilters
        params.filters = filter
        this.updateParams(params)
        this.loadItems()
      }
    },

    // load items is what brings back the rows from server
    async loadItems(isPaginate = false) {
      try {
        await $axios
            .get(this.service, {
              params: this.serverParams,
              timeout: 50000, // timeout 50 segundos
              headers: {
                'Content-Type': 'application/json'
              }
            })
            .then(response => {
              if (response.status === HttpStatus.OK) {
                const data = {data: response.data.data.data, isPaginate}
                this.$emit('update-data', data)
                this.$emit('update-total', response.data.data.total)
              }
            })
            .catch(error => console.log(error))
      } catch (e) {
        console.log('error', e)
      }
    }
  }
}
</script>

<style scoped>
.vgt-left-align.td_center {
  text-align: center;
}

.vgt-table thead tr {
  background-color: #3f9dbd;
}

.vgt-checkbox-col {
  width: 10px;
}

.vgt-wrap__footer .footer__row-count__select {
  padding: 0 12px 0 0 !important;
}

table.dataTable thead th {
  border-radius: unset !important;
}
</style>
